import React from 'react';

import { anelDeFoco, styledDs as styled } from '../../../styles/theme';

export type DsFilterOption = {
  value: string;
  label: string;
};

export type DsFilterPillsProps = {
  options: DsFilterOption[];
  value: string[];
  onChange: (next: string[]) => void;
  multiple?: boolean;
  ariaLabel: string;
};

const Group = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Pill = styled.button<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  height: 30px;
  padding: 0 12px;
  border-radius: ${({ theme }) => theme.radius.pill};
  border: 1px solid ${({ theme, $active }) => ($active ? theme.colors.accent : theme.colors.border)};
  background: ${({ theme, $active }) => ($active ? theme.colors.accentSoft : theme.colors.surface)};
  color: ${({ theme, $active }) => ($active ? theme.colors.accent : theme.colors.textSecondary)};
  font-family: ${({ theme }) => theme.font.family};
  font-size: ${({ theme }) => theme.font.sizeSm};
  font-weight: ${({ theme, $active }) => ($active ? theme.weight.semibold : theme.weight.medium)};
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.accent};
  }

  &:focus-visible {
    ${anelDeFoco()}
  }
`;

export const DsFilterPills: React.FC<DsFilterPillsProps> = ({
  options,
  value,
  onChange,
  multiple = false,
  ariaLabel,
}) => {
  function toggle(optionValue: string) {
    const active = value.includes(optionValue);

    if (multiple) {
      onChange(active ? value.filter((item) => item !== optionValue) : [...value, optionValue]);
      return;
    }

    onChange(active ? [] : [optionValue]);
  }

  return (
    <Group role="group" aria-label={ariaLabel}>
      {options.map((option) => (
        <Pill
          key={option.value}
          type="button"
          $active={value.includes(option.value)}
          aria-pressed={value.includes(option.value)}
          onClick={() => toggle(option.value)}
        >
          {option.label}
        </Pill>
      ))}
    </Group>
  );
};
